import Vue from 'vue';
import {apiPath} from './config.js';
let getWXFromAjax = () => {
	let url = location.href.split('#')[0];
	return new Promise((resolve, reject) => {
		Vue.http.get(apiPath.getJsSdk, {params: {url: url}}).then(
			(data) => {
				let res = data.body;
				if (res.code == '1') {
					resolve(res.data);
				} else {
					// console.log(`获取参数失败。code:${res.code}`)
					reject(`获取参数失败。code:${res.code}`);
				}
			},
			(resp) => {
				// console.log(`请求js参数失败`)
				reject(`请求js参数失败`);
			}
		);
	});
};

export let getWXParams = async () => {
	let debug = false;
	try {
		let config = await getWXFromAjax();
		config.debug = debug;
		config.jsApiList = [
			'onMenuShareTimeline',
			'onMenuShareAppMessage',
			'previewImage'
			// 'startRecord',
			// 'stopRecord',
			// 'onVoiceRecordEnd',
			// 'playVoice',
			// 'pauseVoice',
			// 'stopVoice',
			// 'onVoicePlayEnd',
			// 'uploadVoice',
			// 'downloadVoice',
		];
		return config;
	} catch (e) {
		console.warn(e);
		return {};
	}
};

// 获取系统版本
export let getOsVersion = function () {
	var u = navigator.userAgent,
		version = '';

	if (u.indexOf('Mac OS X') > -1) {
		// ios
		var regStr_saf = /OS [\d._]*/gi;
		var verinfo = u.match(regStr_saf);
		version = 'IOS' + (verinfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.');
	} else if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
		// android
		version =
			'Android' +
			u.substr(
				u.indexOf('Android') + 8,
				u.indexOf(';', u.indexOf('Android')) - u.indexOf('Android') - 8
			);
	} else if (u.indexOf('BB10') > -1) {
		// 黑莓bb10系统
		version =
			'blackberry' +
			u.substr(
				u.indexOf('BB10') + 5,
				u.indexOf(';', u.indexOf('BB10')) - u.indexOf('BB10') - 5
			);
	} else if (u.indexOf('IEMobile') > -1) {
		// windows phone
		version =
			'winphone' +
			u.substr(
				u.indexOf('IEMobile') + 9,
				u.indexOf(';', u.indexOf('IEMobile')) - u.indexOf('IEMobile') - 9
			);
	} else {
		var userAgent = navigator.userAgent.toLowerCase();
		if (userAgent.indexOf('windows nt 5.0') > -1) {
			version = 'Windows 2000';
		} else if (
			userAgent.indexOf('windows nt 5.1') > -1 ||
			userAgent.indexOf('windows nt 5.2') > -1
		) {
			version = 'Windows XP';
		} else if (userAgent.indexOf('windows nt 6.0') > -1) {
			version = 'Windows Vista';
		} else if (
			userAgent.indexOf('windows nt 6.1') > -1 ||
			userAgent.indexOf('windows 7') > -1
		) {
			version = 'Windows 7';
		} else if (
			userAgent.indexOf('windows nt 6.2') > -1 ||
			userAgent.indexOf('windows 8') > -1
		) {
			version = 'Windows 8';
		} else if (userAgent.indexOf('windows nt 6.3') > -1) {
			version = 'Windows 8.1';
		} else if (
			userAgent.indexOf('windows nt 6.2') > -1 ||
			userAgent.indexOf('windows nt 10.0') > -1
		) {
			version = 'Windows 10';
		} else {
			version = 'Unknown';
		}
	}
	return version;
};

/**
 * @param {Number} val 秒数
 * @description 将秒数转为时分秒格式
 */
export const formatDuration = (val = 0) => {
	let days = Math.floor(val / 86400);
	let hours = Math.floor((val % 86400) / 3600);
	let minutes = Math.floor((val % 3600) / 60);
	let seconds = Math.floor(val % 60);
	let str = '';
	if (days > 0) {
		str += `${days}天 `;
	}
	str += [hours, minutes, seconds].join(':');
	return str;
};

/**
 * @name: 获取N天后的初始时间戳
 * @param { Number } afterDay 跟今天相隔的天数，默认为0
 */
export function getDayStartTimeStamp(afterDay = 0) {
	let timeStamp = new Date().setHours(0, 0, 0, 0) + afterDay * 86400000;
	return timeStamp;
}

/**
 * 设置同类多实例的响应缓存（防止缓存内存过大的处理）
 * @param classKey 缓存的一个类型
 * @param key 该缓存类型的一个实例
 * @param val 该缓存实例的值
 * @param expire 该缓存实例的过期时间戳（秒级）
 */
export const setClassStorage = (
	classKey = '',
	key = '',
	val = '',
	expire = Math.floor(Date.now() / 1000) + 7 * 86400
) => {
	console.log(`设置同类多实例的响应缓存:: ${key}:${val}`);
	console.log(`过期时间`, new Date(expire * 1000));
	let getItem = localStorage.getItem(classKey) || '{}';
	let obj = JSON.parse(getItem);
	obj[key] = {
		val,
		e: expire
	};
	if (val === null) {
		delete obj[key];
	}
	let nowTime = Math.floor(Date.now() / 1000);
	let newObj = {};
	Object.keys(obj).forEach((objKey) => {
		let item = obj[objKey];
		if (item.e > nowTime) {
			newObj[objKey] = item;
		}
	});
	console.log(
		`%c 类${classKey}当前的缓存值`,
		'color: orange',
		JSON.stringify(newObj, null, '\t')
	);

	localStorage.setItem(classKey, JSON.stringify(newObj));
};
/**
 * 获取同类多实例的响应缓存
 * @param classKey 缓存的一个类型
 * @param key 该缓存类型的一个实例
 * @return Object {val: key的缓存值, e: key的过期时间戳}
 */
export const getClassStorage = (classKey = '', key = '') => {
	let getItem = localStorage.getItem(classKey) || '{}';

	let obj = JSON.parse(getItem);
	let res = {};
	if (obj && obj[key] && obj[key].e > Math.floor(Date.now() / 1000)) {
		res = obj[key];
	}
	console.log(
		`%c 类${classKey}下实例${key}的缓存:`,
		`color: ${res.e ? 'green' : 'red'};`,
		JSON.stringify(res, null, '\t'),
		res.e ? `\n剩余过期时间:\n${formatDuration(Math.floor(res.e - Date.now() / 1000))}` : ``
	);
	return res;
};



// WEBPACK FOOTER //
// ./src/common/js/utils.js